import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialInstitutionLaboratoryContractApi = {
    getTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryId: (trialInstitutionLaboratoryId: number): Observable<Dtos.GetTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryId = new Dtos.GetTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryId();
        request.trialInstitutionLaboratoryId = trialInstitutionLaboratoryId;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionLaboratoryContractById: (id: number): Observable<Dtos.GetTrialInstitutionLaboratoryContractByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionLaboratoryContractById = new Dtos.GetTrialInstitutionLaboratoryContractById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionLaboratoryContractByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialInstitutionLaboratoryContract: (trialInstitutionLaboratoryContract: Dtos.TrialInstitutionLaboratoryContract): Observable<Dtos.SetTrialInstitutionLaboratoryContractResponse> => {

        let request: Dtos.SetTrialInstitutionLaboratoryContract = new Dtos.SetTrialInstitutionLaboratoryContract();

        request.trialInstitutionLaboratoryContract = trialInstitutionLaboratoryContract;

        // send request
        const response: Promise<Dtos.SetTrialInstitutionLaboratoryContractResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialInstitutionLaboratoryContract: (trialInstitutionLaboratoryId: number): Observable<Dtos.CreateTrialInstitutionLaboratoryContractResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialInstitutionLaboratoryContract = new Dtos.CreateTrialInstitutionLaboratoryContract();

        request.trialInstitutionLaboratoryId = trialInstitutionLaboratoryId;

        //Send request.
        const response: Promise<Dtos.CreateTrialInstitutionLaboratoryContractResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialInstitutionLaboratoryContract: (trialInstitutionLaboratoryContract: Dtos.TrialInstitutionLaboratoryContract): Observable<Dtos.ValidateTrialInstitutionLaboratoryContractResponse> => {

        let request: Dtos.ValidateTrialInstitutionLaboratoryContract = new Dtos.ValidateTrialInstitutionLaboratoryContract();

        request.trialInstitutionLaboratoryContract = trialInstitutionLaboratoryContract;

        // send request
        const response: Promise<Dtos.ValidateTrialInstitutionLaboratoryContractResponse> = client.post(request);

        return Observable.from(response);
    },
    deleteTrialInstitutionLaboratoryContract: (id: number): Observable<Dtos.DeleteTrialInstitutionLaboratoryContractResponse> => {
        //Create the request.
        let request: Dtos.DeleteTrialInstitutionLaboratoryContract = new Dtos.DeleteTrialInstitutionLaboratoryContract();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.DeleteTrialInstitutionLaboratoryContractResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
}